import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styles from '../styles/ServiceSections.module.css';

interface ServiceSectionProps {
  sections: {
    section_1: {
      title: string;
      subtitle: string;
      fullWidthImage?: string;
      services: Array<{
        title: string;
        description: string;
        icon: string;
      }>;
    };
    optimization: {
      title: string;
      description: string;
      icon: string;
    };
    digital: {
      title: string;
      description: string;
      icon: string;
    };
    section_2?: {
      title: string;
      subtitle: string;
      description: string;
      images: string[];
      content: Array<{
        title: string;
        description: string;
        icon: string;
      }>;
    };
    section_3?: {
      title: string;
      subtitle: string;
      description: string;
      images: string[];
    };
  };
}

const ServiceSections: React.FC<ServiceSectionProps> = ({ sections }) => {
  return (
    <section className={styles.serviceSections}>
      {/* section_1 Section */}
      <div className="expansion-section">
        {sections.section_1.fullWidthImage && (
          <div className={styles.fullWidthImage}>
            <img src={sections.section_1.fullWidthImage} alt={sections.section_1.title} />
          </div>
        )}
        <h2 className={styles.sectionTitle}>{sections.section_1.title}</h2>
        <p className={styles.sectionSubtitle}>{sections.section_1.subtitle}</p>

        <div style={{ marginTop: '24px' }}>
          {sections.section_1.services.map((service, index) => (
            <div key={index} className={styles.investmentContent}>
              <div className={styles.checkIcon}>
                <div className={styles.checkCircle}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.5 10.5L3.5 7.5L2.5 8.5L6.5 12.5L13.5 5.5L12.5 4.5L6.5 10.5Z" fill="white" />
                  </svg>
                </div>
              </div>
              <p className={styles.investmentDescription}><span className={styles.investmentTitle}>{service.title}</span> - {service.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* section_2 Section */}
      {sections.section_2 && (
        <div className={styles.investmentSection}>
          <Row className={`g-4 ${styles.investmentImages}`}>
            {sections.section_2.images.map((image, index) => (
              <Col md={6} lg={6} key={index}>
                <div className={styles.imageContainer}>
                  <img src={image} alt={`Investment Opportunity ${index + 1}`} />
                </div>
              </Col>
            ))}
          </Row>
          <h2 className={styles.sectionTitle}>{sections.section_2.title}</h2>
          <p className={styles.sectionSubtitle}>{sections.section_2.subtitle}</p>

          <div>
          {sections.section_2.content.map((service, index) => (
            <div key={index} className={styles.investmentContent}>
              <div className={styles.checkIcon}>
                <div className={styles.checkCircle}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.5 10.5L3.5 7.5L2.5 8.5L6.5 12.5L13.5 5.5L12.5 4.5L6.5 10.5Z" fill="white" />
                  </svg>
                </div>
              </div>
              <p className={styles.investmentDescription}><span className={styles.investmentTitle}>{service.title}</span>  {service.description}</p>
            </div>
          ))}
        </div>
        </div>
      )}
    </section>
  );
};

export default ServiceSections; 